import React, { useState, useEffect, Fragment } from 'react';
import { useTheme } from '@material-ui/styles';
import dayjs from 'dayjs';
import objectSupport from 'dayjs/plugin/objectSupport';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { lighten } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Brush,
    PieChart,
    Pie,
    Cell,
    Radar,
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    ResponsiveContainer,
} from 'recharts';

import { Text, StyledCard, StyledCardContent, Avatar } from '../../index';

import makeMovingAverage from '../../../utils/movingAverage';

import { EXPRESSIONS_COLORS } from '../../../constant';

dayjs.extend(objectSupport);

export const LineChartComponent = ({ data }) => {
    return (
        <ResponsiveContainer width="99%" height="99%">
            <LineChart
                data={data}
                margin={{
                    top: 5,
                    right: 70,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="dateTime" />
                <YAxis type="number" domain={[0, 100]} />
                <Tooltip />

                <Line
                    type="monotone"
                    dataKey="neutral"
                    stroke={EXPRESSIONS_COLORS.neutral}
                    dot={false}
                />
                <Line
                    type="monotone"
                    dataKey="happy"
                    stroke={EXPRESSIONS_COLORS.happy}
                    dot={false}
                />
                <Line type="monotone" dataKey="sad" stroke={EXPRESSIONS_COLORS.sad} dot={false} />
                <Line
                    type="monotone"
                    dataKey="angry"
                    stroke={EXPRESSIONS_COLORS.angry}
                    dot={false}
                />
                <Line
                    type="monotone"
                    dataKey="fearful"
                    stroke={EXPRESSIONS_COLORS.fearful}
                    dot={false}
                />
                <Line
                    type="monotone"
                    dataKey="disgusted"
                    stroke={EXPRESSIONS_COLORS.disgusted}
                    dot={false}
                />
                <Line
                    type="monotone"
                    dataKey="surprised"
                    stroke={EXPRESSIONS_COLORS.surprised}
                    dot={false}
                />

                <Brush dataKey="dateTime" height={30} stroke="#8884d8" />
            </LineChart>
        </ResponsiveContainer>
    );
};

LineChartComponent.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
};

export const LineChartCard = ({ data }) => {
    return (
        <StyledCard>
            <StyledCardContent>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                    }}
                >
                    <Text $fontSize="18px" $bold>
                        Client Emotional Index
                    </Text>
                    {/* <OutlinedButton
                        $width="232px"
                        $height="36px"
                        $color="gray6"
                        style={{ padding: '5px' }}
                    >
                        <div style={{ display: 'flex' }}>
                            <SpeechIcon />
                            <Text $fontSize="12px" $bold style={{ marginLeft: '15px' }}>
                                VIEW SPEECH TO TEXT
                            </Text>
                            <ArrowRightIcon />
                        </div>
                    </OutlinedButton> */}
                </div>
                <div
                    style={{
                        marginTop: '15px',
                        display: 'grid',
                        gridTemplateColumns: '90% auto',
                    }}
                >
                    <div>
                        <div style={{ height: '320px' }}>
                            <LineChartComponent data={data} />
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Text $fontSize="12px" $color="gray1">
                                {/* {`Video Length: ${dayjs()
                                .startOf('date')
                                .second(
                                    dayjs(session.actualEndTime).diff(
                                        dayjs(session.actualStartTime),
                                        'second'
                                    )
                                )
                                .format('HH:mm:ss')} Mins`} */}
                            </Text>
                            <Text $fontSize="12px" $color="gray1">
                                {/* {`From ${dayjs(session.actualStartTime).format('HH:mm:ss')} to ${dayjs(
                                session.actualEndTime
                            ).format('HH:mm:ss')}`} */}
                            </Text>
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            rowGap: '15px',
                            marginTop: '10px',
                        }}
                    >
                        {Object.entries(EXPRESSIONS_COLORS).map(([key, value]) => (
                            <div
                                key={key}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    columnGap: '15px',
                                }}
                            >
                                <div
                                    style={{
                                        width: '20px',
                                        height: '20px',
                                        borderRadius: '4px',
                                        backgroundColor: value,
                                    }}
                                />
                                <Text
                                    $fontSize="12px"
                                    $color="gray1"
                                    style={{ textTransform: 'capitalize' }}
                                >
                                    {key}
                                </Text>
                            </div>
                        ))}
                    </div>
                </div>
            </StyledCardContent>
        </StyledCard>
    );
};

LineChartCard.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
};

export const LineChartSMACard = ({ data }) => {
    const [SMA, setSMA] = useState([]);
    const [period, setPeriod] = useState(30);

    useEffect(() => {
        if (!_.isEmpty(data)) {
            const newSMA = makeMovingAverage(data, period);
            setSMA(newSMA);
        }
    }, [data, period]);

    return (
        <StyledCard>
            <StyledCardContent>
                <div
                    style={{
                        display: 'flex',
                        columnGap: '10px',
                        alignItems: 'center',
                    }}
                >
                    <Text $fontSize="18px" $bold>
                        Client Emotional Index Simple Moving Average
                    </Text>
                    <TextField
                        id="outlined-number"
                        type="number"
                        InputProps={{
                            inputProps: {
                                max: 100,
                                min: 1,
                            },
                        }}
                        variant="outlined"
                        value={period}
                        onChange={(e) => setPeriod(e.target.value)}
                        size="small"
                        margin="none"
                    />
                </div>
                <div
                    style={{
                        marginTop: '15px',
                        display: 'grid',
                        gridTemplateColumns: '90% auto',
                    }}
                >
                    <div>
                        <div style={{ height: '320px' }}>
                            <LineChartComponent data={SMA} />
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Text $fontSize="12px" $color="gray1">
                                {/* {`Video Length: ${dayjs()
                            .startOf('date')
                            .second(
                                dayjs(session.actualEndTime).diff(
                                    dayjs(session.actualStartTime),
                                    'second'
                                )
                            )
                            .format('HH:mm:ss')} Mins`} */}
                            </Text>
                            <Text $fontSize="12px" $color="gray1">
                                {/* {`From ${dayjs(session.actualStartTime).format(
                            'HH:mm:ss'
                        )} to ${dayjs(session.actualEndTime).format('HH:mm:ss')}`} */}
                            </Text>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', rowGap: '15px' }}>
                        {Object.entries(EXPRESSIONS_COLORS).map(([key, value]) => (
                            <div
                                key={key}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    columnGap: '15px',
                                }}
                            >
                                <div
                                    style={{
                                        width: '20px',
                                        height: '20px',
                                        borderRadius: '4px',
                                        backgroundColor: value,
                                    }}
                                />
                                <Text
                                    $fontSize="12px"
                                    $color="gray1"
                                    style={{ textTransform: 'capitalize' }}
                                >
                                    {key}
                                </Text>
                            </div>
                        ))}
                    </div>
                </div>
            </StyledCardContent>
        </StyledCard>
    );
};

LineChartSMACard.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
};

export const PieChartComponent = ({ data }) => {
    return (
        <ResponsiveContainer width="99%" height="99%">
            <PieChart>
                <Pie
                    data={data}
                    cx="50%"
                    cy="50%"
                    innerRadius={55}
                    outerRadius={90}
                    fill="#8884d8"
                    dataKey="percentage"
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={EXPRESSIONS_COLORS[entry.name]} />
                    ))}
                </Pie>
            </PieChart>
        </ResponsiveContainer>
    );
};

PieChartComponent.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
};

const OFFSET = [
    { x: 0, y: -12 },
    { x: 8, y: -5 },
    { x: 5, y: 0 },
    { x: 5, y: 5 },
    { x: -5, y: 5 },
    { x: -20, y: 0 },
    { x: -10, y: -5 },
];

function customTick({ payload, x, y, stroke, radius }) {
    return (
        <g className="recharts-layer recharts-polar-angle-axis-tick">
            <text
                radius={radius}
                stroke={stroke}
                x={x}
                y={y}
                className="recharts-text recharts-polar-angle-axis-tick-value"
                textAnchor="middle"
            >
                <tspan
                    style={{ fontSize: 12, textTransform: 'capitalize' }}
                    x={x + OFFSET[payload.index].x}
                    y={y + OFFSET[payload.index].y}
                    dy="0em"
                    fill={EXPRESSIONS_COLORS[String(payload.value).split(' ')[0]]}
                >
                    {String(payload.value).split(' ')[0]}
                </tspan>
                <tspan
                    style={{ fontSize: 12 }}
                    x={x + OFFSET[payload.index].x}
                    y={y + OFFSET[payload.index].y}
                    dy="1.5em"
                    fill={EXPRESSIONS_COLORS[String(payload.value).split(' ')[0]]}
                >
                    {String(payload.value).split(' ')[1]}
                </tspan>
            </text>
        </g>
    );
}

export const PieChartCard = ({ data }) => {
    return (
        <StyledCard>
            <StyledCardContent>
                <Text $bold>Session Emotional Summary</Text>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)' }}>
                    <PieChartComponent data={data} />
                    <div
                        style={{
                            display: 'grid',
                            alignItems: 'center',
                            gridTemplateColumns: 'auto 1fr',
                            rowGap: '10px',
                            columnGap: '10px',
                        }}
                    >
                        <div></div>
                        <div
                            style={{
                                display: 'grid',
                                alignItems: 'center',
                                gridTemplateColumns: '50% 50%',
                            }}
                        >
                            <Text $color="gray3" $fontSize="12px" style={{ textAlign: 'center' }}>
                                Overall Emotions
                            </Text>
                            <Text $color="gray3" $fontSize="12px" style={{ textAlign: 'center' }}>
                                Occurrences
                            </Text>
                        </div>
                        {_.orderBy(data, ['length'], ['desc']).map((item, index) => (
                            <Fragment key={`value-container-${item.name}`}>
                                <Text
                                    $fontSize="14px"
                                    style={{
                                        color: EXPRESSIONS_COLORS[item.name],
                                        textTransform: 'capitalize',
                                    }}
                                >
                                    {item.name}
                                </Text>
                                <div
                                    style={{
                                        display: 'grid',
                                        alignItems: 'center',
                                        gridTemplateColumns: '50% 50%',
                                        height: '29px',
                                        borderRadius: '6px',
                                        backgroundColor:
                                            index === 0
                                                ? lighten(EXPRESSIONS_COLORS[item.name], 0.8)
                                                : '#F7F8FD',
                                    }}
                                >
                                    <Text $fontSize="14px" style={{ textAlign: 'center' }}>
                                        {item.percentage}%
                                    </Text>
                                    <Text $fontSize="14px" style={{ textAlign: 'center' }}>
                                        {item.length}
                                    </Text>
                                </div>
                            </Fragment>
                        ))}
                    </div>
                </div>
            </StyledCardContent>
        </StyledCard>
    );
};

PieChartCard.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
};

export const RadarChartComponent = ({ data }) => {
    return (
        <ResponsiveContainer width="99%" height="99%">
            <RadarChart cx="52%" cy="50%" data={data}>
                <PolarGrid />
                <PolarAngleAxis dataKey="name" tick={customTick} />
                <PolarRadiusAxis domain={[0, 100]} angle={90} />

                <Radar
                    name="John"
                    dataKey="value"
                    stroke="#82ca9d"
                    fill="#82ca9d"
                    fillOpacity={0.6}
                />
            </RadarChart>
        </ResponsiveContainer>
    );
};

RadarChartComponent.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
};

export const RadarChartCard = ({ data, selected, onClick }) => {
    const theme = useTheme();

    return (
        <StyledCard
            key={data?.patient.id}
            style={{
                padding: '15px',
                border: `1px solid ${
                    selected ? theme.palette.common.blue2 : theme.palette.common.white
                }`,
                cursor: 'pointer',
            }}
            onClick={onClick}
        >
            <StyledCardContent
                style={{
                    display: 'grid',
                    rowGap: '10px',
                    gridTemplateColumns: '1fr',
                    gridTemplateRows: 'auto 300px',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        columnGap: '15px',
                        padding: '10px',
                        borderRadius: '12px',
                        border: `1px solid ${theme.palette.common.gray6}`,
                        backgroundColor: theme.palette.common.shadeGrayGradient,
                    }}
                >
                    <Avatar
                        alt={!data?.patient?.user ? '' : data?.patient?.user?.fullname}
                        src={!data?.patient?.user ? null : data?.patient?.user?.avatar?.url}
                        $avatarSize="48px"
                    />

                    <Text $ellipsis $bold $fontSize="14px">
                        {!data?.patient?.user ? 'Inactive' : data?.patient?.user?.fullname}
                    </Text>
                </div>
                <div style={{ paddingLeft: '10px' }}>
                    <RadarChartComponent data={data?.expression} />
                </div>
            </StyledCardContent>
        </StyledCard>
    );
};

RadarChartCard.propTypes = {
    data: PropTypes.object,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
};
